import store from "@/store";
import {orderService} from "@/_api/order.api";
import { constants } from '@/constants/constants';
import {
	getUpsellTitle,
	isUpsell,
} from '@/_helpers/order';

export const formatDataService = {

	formatItemsForAPI(items, createOrder) {
		let obj1 = JSON.parse(JSON.stringify(items));

		return obj1.map((obj) => {
			let objToSend = {};
			const condiments = [];
			const modifiers = [];
			const we = [];

			if (
				obj.combo
				|| obj.orderable_type === "App\\Models\\MenuCombo"
			) {
				obj.items.forEach((oq) => {
					let temp = {
						menu_combo_item_id:
							oq.menu_combo_item_id
								? oq.menu_combo_item_id
								: oq.id,
						modifiers: [],
						condiments: []
					};

					if (oq.menu_combo_item_id) {
						temp['id'] = oq.id;
					}

					if (obj.remove_id) {
						delete temp['id'];
					}

					we.push(temp);
				});
			}

			if (
				obj.condiments_parsed
				&& obj.condiments_parsed.length
			) {
				obj.condiments_parsed.forEach((condiment) => {
					if (
						condiment.type === 1
						|| condiment.checked
					) {
						condiment.items.forEach(
							(condimentItem) => {
								if (!condimentItem.checked) {
									return;
								}

								const condimentPayload = {
									menu_item_condiment_id:
										condimentItem
											.menu_item_condiment_id,
									count:
										obj.count
										* condimentItem.count,
									menu_combo_item_id:
										condiment.combo_item_id
								};

								if (condiment.position_id) {
									condimentPayload['id'] =
										condiment.position_id;
								}

								condiments.push(
									condimentPayload
								);
							}
						);
					}
				});
			}

			if (
				obj.modifiers_parsed
				&& obj.modifiers_parsed.length
			) {
				obj.modifiers_parsed.forEach((modifier) => {
					let shouldObjectBeAdded = true;

					let modifierPayload = {
						menu_combo_item_id:
							modifier.combo_item_id,
						menu_item_modifier_id:
							modifier.menu_item_modifier_id
								? modifier.menu_item_modifier_id
								: modifier.id,
						free_text: null
					};

					if (modifier.menu_item_modifier_id) {
						modifierPayload['id'] = modifier.id;
					}

					if (modifier.is_required) {
						modifierPayload['options'] = [];

						const checkedOptions =
							modifier.options.filter(
								(option) => {
									return option.checked;
								}
							);

						if (checkedOptions.length) {
							checkedOptions.forEach(
								(option) => {
									if (option.id === null) {
										modifierPayload[
											'free_text'
										] = option.name;
									}

									if (option.id !== null) {
										modifierPayload[
											'options'
										].push(option.id);
									}
								}
							);
						}
					} else {
						const checkedOptions =
							modifier.options.filter(
								(option) => {
									return option.checked;
								}
							);

						const freeTextOptionIndex =
							checkedOptions.findIndex(
								(option) => {
									return option.id === null;
								}
							);

						const selectedOptionIds =
							checkedOptions
								.filter((option) => {
									return option.id !== null;
								})
								.map((option) => {
									return option.id;
								});

						if (
							modifier.options.filter(
								(option) => {
									return option.id !== null;
								}
							).length
						) {
							modifierPayload['options'] =
								selectedOptionIds;
						}

						if (freeTextOptionIndex !== -1) {
							modifierPayload['free_text'] =
								checkedOptions[
									freeTextOptionIndex
								].name;
						}

						const isUncheckedWithoutOptions =
							!modifier.has_free_text
							&& !modifier.options.length
							&& !modifier.checked;

						const isFreeTextEmpty =
							modifier.has_free_text
							&& !checkedOptions.length;

						const isOptionalOptionsEmpty =
							!modifier.has_free_text
							&& modifier.options.length
							&& !checkedOptions.length;

						if (
							isUncheckedWithoutOptions
							|| isFreeTextEmpty
							|| isOptionalOptionsEmpty
						) {
							shouldObjectBeAdded = false;
						}
					}

					if (shouldObjectBeAdded) {
						modifiers.push(modifierPayload);
					}
				});
			}

			condiments.forEach((condiment) => {
				const tempId =
					condiment.menu_combo_item_id;

				delete condiment.menu_combo_item_id;

				we.forEach((comboItem) => {
					if (
						tempId
						=== comboItem.menu_combo_item_id
					) {
						comboItem.condiments.push(
							condiment
						);
					}
				});
			});

			modifiers.forEach((modifier) => {
				const tempId =
					modifier.menu_combo_item_id;

				delete modifier.menu_combo_item_id;

				we.forEach((comboItem) => {
					if (
						tempId
						=== comboItem.menu_combo_item_id
					) {
						comboItem.modifiers.push(
							modifier
						);
					}
				});
			});

			objToSend = {
				id: obj.id,
				seat: obj.seat ? obj.seat : 1,
                ...(obj.kitchen_round != null ? {kitchen_round: Number(obj.kitchen_round)} : {}),
				count: obj.count,
				price: obj.price,
				status: obj.status,
				upsell_showed: !!obj.upsell_showed,
				condiments,
				modifiers,
				items: we,
				orderable_id: obj.orderable_id,
				orderable_type: obj.orderable_type,
				print_in_min:
					obj.print_in_min
						? obj.print_in_min
						: null
			};

			if (obj.open_price) {
				objToSend['open_price_value'] =
					obj.open_price_value;

				objToSend['open_price_type'] =
					obj.open_price_type;
			}

			objToSend = this.addDiscountToPayload(
				objToSend,
				obj
			);

			if (obj.remove_id) {
				delete objToSend['id'];
			}

			return objToSend;
		});
	},

	addDiscountToPayload(payload, order) {
		payload['m_discount_type'] =
			order?.m_discount_type
			?? constants.discountTypes.amount;

		const deleteEmptyPercentageDiscount = (
			discountPercentage
		) => {
			const needDeletePercentageDiscount =
				Boolean(
					!discountPercentage
					|| Number.isNaN(discountPercentage)
					|| discountPercentage === 0
				);

			if (needDeletePercentageDiscount) {
				delete payload[
					'm_discount_percentage'
				];

				payload['m_discount_type'] = null;
			}
		};

		const deleteEmptyAmountDiscount = (
			discountAmount
		) => {
			const needDeleteAmountDiscount =
				Boolean(
					!discountAmount
					|| Number.isNaN(discountAmount)
					|| discountAmount === 0
				);

			if (needDeleteAmountDiscount) {
				delete payload['m_discount_amount'];
				payload['m_discount_type'] = null;
			}
		};

		switch (payload['m_discount_type']) {
			case constants.discountTypes.percentage: {
				const discountPercentage =
					order.m_discount_percentage
						? parseFloat(
							order.m_discount_percentage
						)
						: null;

				payload['m_discount_percentage'] =
					discountPercentage;

				delete payload['m_discount_amount'];

				deleteEmptyPercentageDiscount(
					discountPercentage
				);

				break;
			}

			case constants.discountTypes.amount: {
				const discountAmount =
					order.m_discount_amount
						? parseFloat(
							order.m_discount_amount
						)
						: null;

				payload['m_discount_amount'] =
					discountAmount;

				delete payload[
					'm_discount_percentage'
				];

				deleteEmptyAmountDiscount(
					discountAmount
				);

				break;
			}
		}

		return payload;
	},

	addGratuityToPayload(payload, order) {
		payload['gratuity_type'] =
			order?.gratuity_type
			?? constants.gratuityTypes.amount;

		const deleteEmptyPercentageGratuity = (
			gratuityPercentage
		) => {
			const needDeletePercentageGratuity =
				Boolean(
					!gratuityPercentage
					|| Number.isNaN(gratuityPercentage)
					|| gratuityPercentage === 0
				);

			if (needDeletePercentageGratuity) {
				delete payload['gratuity_percent'];
				payload['gratuity_type'] = null;
			}
		};

		const deleteEmptyAmountGratuity = (
			gratuityAmount
		) => {
			const needDeleteAmountGratuity =
				Boolean(
					!gratuityAmount
					|| Number.isNaN(gratuityAmount)
					|| gratuityAmount === 0
				);

			if (needDeleteAmountGratuity) {
				delete payload['gratuity_amount'];
				payload['gratuity_type'] = null;
			}
		};

		switch (payload['gratuity_type']) {
			case constants.gratuityTypes.percentage: {
				const gratuityPercentage =
					order.gratuity_percent
						? parseFloat(
							order.gratuity_percent
						)
						: null;

				payload['gratuity_percent'] =
					gratuityPercentage;

				delete payload['gratuity_amount'];

				deleteEmptyPercentageGratuity(
					gratuityPercentage
				);

				break;
			}

			case constants.gratuityTypes.amount: {
				const gratuityAmount =
					order.gratuity_amount
						? parseFloat(
							order.gratuity_amount
						)
						: null;

				payload['gratuity_amount'] =
					gratuityAmount;

				delete payload['gratuity_percent'];

				deleteEmptyAmountGratuity(
					gratuityAmount
				);

				break;
			}
		}

		return payload;
	},

	formatItemCondiments(el, menuItem, isCombo) {
		const arrParser = (data) => {
			const parsedCondiments = [];

			const getUpsellData = (condiment) => {
				return {
					isUpsell: isUpsell(condiment),
					upsellTitle:
						getUpsellTitle(condiment),
				};
			};

			const condiments = menuItem
				? data.condiments
				: data.available_condiments;

			if (condiments && condiments.length) {
				condiments.forEach((condiment) => {
					condiment.menu_item[
						'orderable_type'
					] = 'App\\Models\\MenuItem';

					const condimentIndex =
						parsedCondiments.findIndex(
							(currentCondiment) => {
								return (
									currentCondiment.name
									=== condiment.name
								);
							}
						);

					if (condimentIndex === -1) {
						const modifiers =
							condiment.modifiers?.map(
								(
									modifier,
									modifierIndex
								) => {
									const hasOptions =
										modifier
											?.options
											?.length > 0;

									const needCheckFirstOption =
										Boolean(
											modifierIndex === 0
											&& modifier
												.is_required
											&& hasOptions
										);

									if (
										needCheckFirstOption
									) {
										modifier.checked =
											true;

										modifier.options[
											0
										].checked = true;
									}

									const lastOption =
										modifier.options[
											modifier.options
												.length - 1
										];

									const needAddFreeText =
										Boolean(
											modifier
												.has_free_text
											&& (
												(
													modifier
														.options
														.length
													&& lastOption
														.id
														!== null
												)
												|| !modifier
													.options
													.length
											)
										);

									if (needAddFreeText) {
										modifier.options.push({
											id: null,
											type: 'free_text',
											name: '',
											checked: false
										});
									}

									return modifier;
								}
							) ?? [];

						const parsedCondiment = {
							type: condiment.type,
							name: condiment.name,
							combo_item_id: menuItem
								? data.id
								: (
									isCombo
										? data
											.menu_combo_item_id
										: data.id
								),
							items: [],
							price: condiment.price,
							count: condiment.count,
							menu_item:
								condiment.menu_item,
							modifiers,
						};

						parsedCondiment.items = [{
							menu_item_condiment_id:
								condiment.id,
							menu_item_id:
								condiment.menu_item.id,
							count: condiment.count,
							price: condiment.price,
							name:
								condiment.menu_item.name,
							...getUpsellData(condiment),
							checked: false,
						}];

						parsedCondiments.push(
							parsedCondiment
						);
					} else {
						parsedCondiments[
							condimentIndex
						].items.push({
							menu_item_condiment_id:
								condiment.id,
							menu_item_id:
								condiment.menu_item.id,
							count: condiment.count,
							price: condiment.price,
							name:
								condiment.menu_item.name,
							...getUpsellData(condiment),
							checked: false,
							discount: 55
						});
					}
				});
			}

			parsedCondiments.forEach((condiment) => {
				if (condiment.type === 1) {
					condiment.items[0].checked = true;
				}
			});

			return parsedCondiments;
		};

		let parsedCondiments = [];

		const selectedParser = (selectedItem) => {
			parsedCondiments.forEach((condiment) => {
				selectedItem.condiments.forEach(
					(selectedCondiment) => {
						if (
							selectedCondiment
								.menu_item_condiment
								.name
							=== condiment.name
						) {
							condiment.checked = true;

							condiment.items.forEach(
								(condimentItem) => {
									condimentItem.checked =
										false;

									if (
										condimentItem
											.menu_item_condiment_id
										=== selectedCondiment
											.menu_item_condiment
											.id
									) {
										condimentItem
											.checked = true;
									}
								}
							);

							condiment['position_id'] =
								selectedCondiment.id;
						}
					}
				);
			});
		};

		if (isCombo) {
			el.items.forEach((item) => {
				parsedCondiments = [
					...parsedCondiments,
					arrParser(item)
				];
			});

			parsedCondiments =
				parsedCondiments.flat(1);

			if (!menuItem) {
				el.items.forEach((item) => {
					item['menu_item_id'] =
						item.menu_combo_item_id;

					selectedParser(item);
				});
			}
		} else {
			parsedCondiments = arrParser(el);

			if (!menuItem) {
				selectedParser(el);
			}
		}

		return parsedCondiments;
	},

	formatItemModifiers(el, menuItem, isCombo) {
		const arrParser = (data) => {
			const modifiers = menuItem
				? (
					isCombo
						? data.menu_item.modifiers
						: data.modifiers
				)
				: data.available_modifiers;

			return modifiers?.map((modifier) => {
				const lastOption =
					modifier.options[
						modifier.options.length - 1
					];

				const needAddFreeText = Boolean(
					modifier.has_free_text
					&& (
						(
							modifier.options.length
							&& lastOption.id !== null
						)
						|| !modifier.options.length
					)
				);

				if (needAddFreeText) {
					modifier.options.push({
						id: null,
						type: 'free_text',
						name: '',
						checked: false
					});
				}

				const transformedModifier = {
					...modifier,
					checked: !!modifier.is_required
				};

				if (menuItem || !data.orderable_type) {
					return {
						...transformedModifier,
						combo_item_id: menuItem
							? data.id
							: data.menu_combo_item_id
					};
				}

				return transformedModifier;
			});
		};

		let parsedModifiers = [];

		const selectedParser = (selectedItem) => {
			parsedModifiers?.forEach((modifier) => {
				selectedItem.modifiers.forEach(
					(selectedModifier) => {
						if (
							selectedModifier
								.menu_item_modifier.id
							!== modifier.id
						) {
							return;
						}

						modifier['id'] =
							selectedModifier.id;

						modifier[
							'menu_item_modifier_id'
						] = selectedModifier
							.menu_item_modifier.id;

						modifier[
							'combo_item_position_id'
						] = selectedItem.id;

						if (
							selectedModifier
								.menu_item_modifier
								.is_required
						) {
							if (
								selectedModifier
									.options.length
							) {
								modifier.options.forEach(
									(option) => {
										option[
											'checked'
										] = false;

										selectedModifier
											.options
											.forEach(
												(
													selectedOption
												) => {
													if (
														option.id
														=== selectedOption
															.id
													) {
														option[
															'checked'
														] = true;
													}
												}
											);

										if (
											option.id
											=== null
										) {
											option[
												'checked'
											] = Boolean(
												selectedModifier
													.free_text
											);

											option[
												'name'
											] = selectedModifier
												.free_text;
										}
									}
								);
							} else {
								modifier.options.forEach(
									(option) => {
										option[
											'checked'
										] = false;

										if (
											option.id
											=== null
										) {
											option[
												'checked'
											] = true;

											option[
												'name'
											] = selectedModifier
												.free_text;
										}
									}
								);
							}
						} else {
							modifier.options.forEach(
								(option) => {
									selectedModifier
										.options
										.forEach(
											(
												selectedOption
											) => {
												if (
													option.id
													=== selectedOption
														.id
												) {
													option[
														'checked'
													] = true;
												}
											}
										);
								}
							);

							if (
								!selectedModifier.free_text
								&& !selectedModifier
									.options.length
							) {
								modifier['checked'] =
									true;
							}

							if (
								modifier.options.some(
									(option) => {
										return option.checked;
									}
								)
							) {
								modifier.checked = true;
							}

							if (
								selectedModifier.free_text
							) {
								const freeTextOption =
									modifier.options[
										modifier.options
											.length - 1
									];

								freeTextOption['name'] =
									selectedModifier
										.free_text;

								freeTextOption['checked'] =
									true;
							}
						}
					}
				);
			});
		};

		if (isCombo) {
			el.items.forEach((item) => {
				parsedModifiers = [
					...parsedModifiers,
					arrParser(item)
				];
			});

			parsedModifiers =
				parsedModifiers.flat(1);

			if (!menuItem) {
				el.items.forEach((item) => {
					item['menu_item_id'] =
						item.menu_combo_item_id;

					selectedParser(item);
				});
			}
		} else {
			parsedModifiers = arrParser(el);

			if (!menuItem) {
				selectedParser(el);
			}
		}

		return parsedModifiers;
	},

	handleCondimentsModifiers(items) {
		items.forEach((item) => {
			item['combo'] =
				item.orderable_type
				=== "App\\Models\\MenuCombo";

			item['modifiers_parsed'] =
				formatDataService
					.formatItemModifiers(
						item,
						false,
						item['combo']
					);

			item['condiments_parsed'] =
				formatDataService
					.formatItemCondiments(
						item,
						false,
						item['combo']
					);
		});

		return items;
	},
};